export default __webpack_public_path__ + "static/media/china.45341896.jpg";